import React from 'react'
import emojiRegex from 'emoji-regex'
import { useEmojiNameToDisplayMap } from 'hooks/useEmojiState'
import { getTwEmoji } from 'utils/emojiUtil'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import { MetricCategoryItemStrings } from 'enums/MetricCategoryItem'
import { getEmoji } from '../InsightChart/BaseInsightChart'
import { DisplayedName } from '../InsightChart/StarRatingChart'
import { getSurveyScoreName } from '../utils'

const FormatedName = ({
  name,
  viewOption
}: {
  name: string
  viewOption: InsightViewOptionStrings
}) => {
  const emojiNameToDisplayMap = useEmojiNameToDisplayMap()

  switch (viewOption) {
    case InsightViewOption.STAR_RATINGS:
      return <DisplayedName name={name as MetricCategoryItemStrings} />

    case InsightViewOption.SURVEY_SCORES:
      return <>{getSurveyScoreName(name as MetricCategoryItemStrings)}</>

    case InsightViewOption.EMOJIS_EMOJI:
    case InsightViewOption.EMOJIS_EMOTION:
    case InsightViewOption.EMOJIS_GROUP:
      return <>{getEmoji(name, emojiNameToDisplayMap)}</>

    default:
      return <>{emojiRegex().test(name) ? getTwEmoji(name) : name}</>
  }
}

export default FormatedName
